unable to read source [project]/workspace/frontend/src/option.ts